import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {ProleisSuppliersState} from '../../../../store/store.index';
import {ActivatedRoute} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {PositionActions, PositionSelectors} from '../../../../store/positions/position.index';
import {FileResponse} from '../../../../../models/file.response';
import {saveAs} from 'file-saver';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {UploadPmDocumentComponent, UploadPmDocumentData} from './dialogs/upload.pm.document.component';
import {DocumentService, ProleisObject} from "@proleis/proleis-rest-client";
import {LoadingService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-pm-documents',
  templateUrl: 'pm.documents.component.html',
  styleUrls: ['pm.documents.component.scss']
})
export class PmDocumentsComponent implements OnInit {

  documents$: Observable<Map<string, ProleisObject[]>>;
  pos$: Observable<ProleisObject>;

  groupSelectControl: FormControl;

  constructor(private store: Store<ProleisSuppliersState>, private route: ActivatedRoute, private ds: DocumentService,
              private loadingService: LoadingService, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.groupSelectControl = new FormControl('DOKUMENTART');
    this.store.dispatch(PositionActions.LOAD_POSITION({
      pboId: this.route.snapshot.params.id,
      posId: this.route.snapshot.params.posId
    }));
    this.pos$ = this.store.select(PositionSelectors.selectPosition);

    this.store.dispatch(PositionActions.LOAD_PM_DOCUMENTS({
      objectId: this.route.snapshot.params.posId,
      aliasFields: 'DOKUMENTFORM=DOKUMENTFORM_ID.NAME;DOKUMENTART=DOKUMENTART_ID.NAME;ERSTELLERNAME=ERSTELLER_ID.NAME'
    }));


    this.documents$ = combineLatest([
      this.store.select(PositionSelectors.selectPmDocuments),
      this.groupSelectControl.valueChanges.pipe(startWith('DOKUMENTART'))
    ]).pipe(
      map(([documents, groupField]) => {
        let grouped = new Map<string, ProleisObject[]>();
        const uniques = [...new Set(documents.map(doc => doc[this.groupSelectControl.value]))];
        uniques.forEach(un => {
          grouped = grouped.set(un, documents.filter(doc => doc[this.groupSelectControl.value] === un));
        });
        return grouped;
      })
    );
  }

  downloadDocument(doc: ProleisObject) {
    this.loadingService.setBlocking('DOC_DOWNLOAD', true, 'Lade Dokument herunter...');
    this.ds.getDocumentFile(doc.OBJECT_ID).subscribe(response => {
      const fileResponse: FileResponse = FileResponse.parseResponse(response);
      saveAs(fileResponse.content, fileResponse.fileName);
      this.loadingService.setBlocking('DOC_DOWNLOAD', false, '');
    });
  }

  uploadDocument() {
    this.pos$.subscribe(pos => {
      const data: UploadPmDocumentData = {
        containerId: pos.OBJECT_ID
      };
      this.dialog.open(UploadPmDocumentComponent, {
        data
      });
    });
  }

}
